import type { ContactDto, SaveContactBody, StartContactChatBody } from '@chat-emp/shared';

import { apiFetch } from '../lib/api.js';

const json = (body: unknown): RequestInit => ({
  method: 'POST',
  headers: { 'content-type': 'application/json' },
  body: JSON.stringify(body),
});

export function listContacts(): Promise<ContactDto[]> {
  return apiFetch<ContactDto[]>('/api/contacts');
}

export function saveContact(body: SaveContactBody): Promise<ContactDto> {
  return apiFetch<ContactDto>('/api/contacts', json(body));
}

export function deleteContact(id: string): Promise<void> {
  return apiFetch<void>(`/api/contacts/${encodeURIComponent(id)}`, { method: 'DELETE' });
}

export function startContactChat(body: StartContactChatBody): Promise<{ channelId: string }> {
  return apiFetch<{ channelId: string }>('/api/contacts/start', json(body));
}
